import GraphLibAdapter from "./graph-lib-adapter";
import { JagmRawLineSignalData } from "@incartdev/jagm-chart";

export class GraphNavAdapter extends GraphLibAdapter {
    config;

    constructor(props) {
        super(props);
        this.config = [{ start: 0, stop: 1 }];
    }

    plotData = async signalData => {
        const promises = [];
        this.chartProvider.signalObjectGroups.map(async signalGroup => {
            const preparedSignalData = new JagmRawLineSignalData(signalData);
            promises.push(signalGroup.addSignalData(0, 0, 0, preparedSignalData));
        });

        await Promise.all(promises);
        this.visProvider?.refreshGraphics();
    };

    clearGraph = async () => {
        const promises = [];
        for (let signalGroupIndex = 0; signalGroupIndex < this.chartProvider.signalObjectGroups.length; ++signalGroupIndex) {
            const signalGroup = this.chartProvider.signalObjectGroups[signalGroupIndex];
            const config = this.config[signalGroupIndex];
            for (let index = config.start; index < config.stop; index++) {
                promises.push(signalGroup.clearSignalData(0, 0, index));
            }
        }

        await Promise.all(promises);
    };

    onResize = callback => {
        this.chartProvider.charts[0].addEventListener("UpdateBorders", callback);
    };
}
